import { DateTimeFormComponent } from "components/Form/components/DateTime/DateTimeFormComponent";
import { convertMomentObjToDayjs } from "config/ts-utils";
import { Field } from "react-final-form";

export const DateTimeFilter = ({ name, label }: { name: string; label: string }) => {
    return (
        <Field name={name} id={name}>
            {({ input, meta }) => (
                <DateTimeFormComponent
                    input={{
                        ...input,
                        onChange: (value) => input.onChange(convertMomentObjToDayjs(value)),
                    }}
                    meta={meta}
                    fieldProps={{ label }}
                    fieldAttr={{}}
                />
            )}
        </Field>
    );
};
